module.exports = __webpack_public_path__ + "static/media/hero_img_high_potential.e90d4564.png";